import { CreatePasswordRecovery } from 'domain/usecases/password/remote';
import { BadRequestError, Forbidden, UnexpectedError } from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteCreatePasswordRecovery implements CreatePasswordRecovery {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreatePasswordRecovery.Model>;

  constructor(
    url: string,
    httClient: HttpClient<CreatePasswordRecovery.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  create = async (
    params: CreatePasswordRecovery.Params,
  ): Promise<CreatePasswordRecovery.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return {};
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
